import { BaseAddUpdateComponent } from './base-add-update-component';
import { IBaseService } from '../service/ibase-service';
import { ToastrService } from 'ngx-toastr';
import { Router } from '@angular/router';
import { ResponseCode } from '../constant/response-code';
import { FormGroup, Validators } from '@angular/forms';
import { Output, EventEmitter, Input } from '@angular/core';
import { VALIDATION_CONFIGURATION } from 'src/environments/configuration';
import { AclDataModal } from 'src/app/shared/sidebar/acl-data-modal';
import { environment } from 'src/environments/environment';

export abstract class AbstractBaseAddUpdateComponent<T> implements BaseAddUpdateComponent<T> {
  @Output('onSaved')
  public onSavedCallback: EventEmitter<T> = new EventEmitter<T>();

  @Input('isModelComponent')
  public isModelComponent: boolean = false;

  @Input() public id: number;

  supressMessage: boolean = false;

  @Output('onModalComponentSave')
  public saveCallback: EventEmitter<T> = new EventEmitter<T>();

  @Output('onModalComponentCancel') 
  public cancelCallback: EventEmitter<T> = new EventEmitter<T>();

  public isUpdateComponent: boolean = false;
  public submitted: boolean = false;
  public validationConfiguration = VALIDATION_CONFIGURATION;
  public isUserAllow: boolean;
  constructor(private toastr: ToastrService, private routerSrv: Router) {}

  public isDeleteAllow: boolean = true;
  public isEditAllow: boolean = true;
  public isViewAllow: boolean = true;
  public isAddAllow: boolean = true;

  // all abstract methods for ADD-UPDATE component
  abstract getService(): IBaseService<T>;
  abstract setData(T);
  abstract getData(): T;
  abstract getModuleHomeUrl();
  abstract getActiveRoute();
  abstract getNewModal();
  abstract getFormGroup(): FormGroup;
  abstract setValidation();
  abstract getId(): number;

  init() {
    this.initAcl();
    if(!this.isModelComponent){
      if (this.getActiveRoute() && this.getActiveRoute().params) {
        this.getActiveRoute().params.subscribe((param) => {
          let id = param['id'];
          if (id) {
            this.isUpdateComponent = true;
            let catModal = this.getNewModal();
            catModal.id = id;
            this.getById(id);
            return;
          }
          this.setData(this.getNewModal());
        });
      }
    }
    else{
      let id = this.id;
      if (id) {
        this.isUpdateComponent = true;
        let catModal = this.getNewModal();
        catModal.id = id;
        this.getById(id);
      }
    }
    this.authRole();
    this.setData(this.getNewModal());
    this.setValidation();
  }

  initV2() {
    if(!this.isModelComponent){
      if (this.getActiveRoute() && this.getActiveRoute().params) {
        this.getActiveRoute().params.subscribe((param) => {
          let id = param['id'];
          if (id) {
            this.isUpdateComponent = true;
            let catModal = this.getNewModal();
            catModal.id = id;
            this.getByIdV2(id);
            return;
          }
          this.setData(this.getNewModal());
        });
      }
    }else{
      let id = this.id;
      if (id) {
        this.isUpdateComponent = true;
        let catModal = this.getNewModal();
        catModal.id = id;
        this.getByIdV2(id);
      }
    }
    this.authRole();
    this.setData(this.getNewModal());
    this.setValidation();
  }

  initV3() {
    if(!this.isModelComponent){
      if (this.getActiveRoute() && this.getActiveRoute().params) {
        this.getActiveRoute().params.subscribe((param) => {
          let id = param['id'];
          if (id) {
            this.isUpdateComponent = true;
            let catModal = this.getNewModal();
            catModal.id = id;
            this.getByIdV3(id);
            return;
          }
          this.setData(this.getNewModal());
        });
      }
    }else{
      let id = this.id;
      if (id) {
        this.isUpdateComponent = true;
        let catModal = this.getNewModal();
        catModal.id = id;
        this.getByIdV3(id);
      }
    }
    this.authRole();
    this.setData(this.getNewModal());
    this.setValidation();
  }

  save(modal: T) {
    console.log(JSON.stringify(modal), 'formdata');
    this.getService()
      .save(modal)
      .subscribe(
        (response) => {
          if (response.responseCode != ResponseCode.OK) {
            this.onResponseError(response.responseMessage);
            return;
          }
          //this.setData(response.data);
          if(this.isModelComponent){
            this.saveCallback.emit(response.data);
          }
          this.onSaveSuccess();
        },
        (error) => {
          this.onResponseError(error.message);
        }
      );
  }

  saveV2(modal: T) {
    // console.log(JSON.stringify(modal), 'formdata');
    this.getService()
      .saveV2(modal)
      .subscribe(
        (response) => {
          if (response.responseCode != ResponseCode.OK) {
            this.onResponseError(response.responseMessage);
            return;
          }
          //this.setData(response.data);
          this.onSavedCallback.emit(response.data);
          this.onSaveSuccess();
        },
        (error) => {
          this.onResponseError(error.message);
        }
      );
  }
  saveV3(modal: T) {
    // console.log(JSON.stringify(modal), 'formdata');
    this.getService()
      .saveV3(modal)
      .subscribe(
        (response) => {
          if (response.responseCode != ResponseCode.OK) {
            this.onResponseError(response.responseMessage);
            return;
          }
          //this.setData(response.data);
          this.onSavedCallback.emit(response.data);
          this.onSaveSuccess();
        },
        (error) => {
          this.onResponseError(error.message);
        }
      );
  }

  saveWithImage(modal: T) {
    this.getService()
      .saveWithImage(modal, this.getFile())
      .subscribe(
        (response) => {
          if (response.responseCode != ResponseCode.OK) {
            this.onResponseError(response.responseMessage);
            return;
          }
          //this.setData(response.data);
          this.onSavedCallback.emit(response.data);
          this.onSaveSuccess();
        },
        (error) => {
          this.onResponseError(error.message);
        }
      );
  }

  saveWithImageV2(modal: T) {
    this.getService()
      .saveWithImageV2(modal, this.getFile())
      .subscribe(
        (response) => {
          if (response.responseCode != ResponseCode.OK) {
            this.onResponseError(response.responseMessage);
            return;
          }
          //this.setData(response.data);
          this.onSavedCallback.emit(response.data);
          this.onSaveSuccess();
        },
        (error) => {
          this.onResponseError(error.message);
        }
      );
  }

  saveWithImageV3(modal: T) {
    this.getService()
      .saveWithImageV3(modal, this.getFile())
      .subscribe(
        (response) => {
          if (response.responseCode != ResponseCode.OK) {
            this.onResponseError(response.responseMessage);
            return;
          }
          //this.setData(response.data);
          this.onSavedCallback.emit(response.data);
          this.onSaveSuccess();
        },
        (error) => {
          this.onResponseError(error.message);
        }
      );
  }

  updateWithImage(modal: T) {
    this.getService()
      .updateWithImage(modal, this.getFile())
      .subscribe(
        (response) => {
          if (response.responseCode != ResponseCode.OK) {
            this.onResponseError(response.responseMessage);
            return;
          }
          //this.setData(response.data);
          this.onSavedCallback.emit(response.data);
          this.onSaveSuccess();
        },
        (error) => {
          this.onResponseError(error.message);
        }
      );
  }

  updateWithImageV2(modal: T) {
    this.getService()
      .updateWithImageV2(modal, this.getFile())
      .subscribe(
        (response) => {
          if (response.responseCode != ResponseCode.OK) {
            this.onResponseError(response.responseMessage);
            return;
          }
          //this.setData(response.data);
          this.onSavedCallback.emit(response.data);
          this.onSaveSuccess();
        },
        (error) => {
          this.onResponseError(error.message);
        }
      );
  }

  updateWithImageV3(modal: T) {
    this.getService()
      .updateWithImageV3(modal, this.getFile())
      .subscribe(
        (response) => {
          if (response.responseCode != ResponseCode.OK) {
            this.onResponseError(response.responseMessage);
            return;
          }
          //this.setData(response.data);
          this.onSavedCallback.emit(response.data);
          this.onSaveSuccess();
        },
        (error) => {
          this.onResponseError(error.message);
        }
      );
  }

  onSave() {
    this.save(this.getData());
  }

  onSaveV2() {
    this.saveV2(this.getData());
  }

  onSaveV3() {
    this.saveV3(this.getData());
  }
 

  onSaveWithImage() {
    this.saveWithImage(this.getData());
  }
  onSaveWithImageV2() {
    this.saveWithImageV2(this.getData());
  }

  onSaveWithImageV3() {
    this.saveWithImageV3(this.getData());
  }

  onUpdateWithImage() {
    this.updateWithImage(this.getData());
  }
  onUpdateWithImageV2() {
    this.updateWithImageV2(this.getData());
  }

  onUpdateWithImageV3() {
    this.updateWithImageV3(this.getData());
  }
  update(modal: T) {
    // console.log(JSON.stringify(modal));
    this.getService()
      .update(modal)
      .subscribe(
        (response) => {
          if (response.responseCode != ResponseCode.OK) {
            this.onResponseError(response.responseMessage);
            return;
          }
          //this.setData(response.data);
          if(this.isModelComponent){
            this.saveCallback.emit(response.data);
          }
          this.onSaveSuccess();
        },
        (error) => {
          this.onResponseError(error.message);
        }
      );
  }

  updateV2(modal: T) {
    // console.log(JSON.stringify(modal));
    this.getService()
      .updateV2(modal)
      .subscribe(
        (response) => {
          if (response.responseCode != ResponseCode.OK) {
            this.onResponseError(response.responseMessage);
            return;
          }
          //this.setData(response.data);
          if(this.isModelComponent){
            this.saveCallback.emit(response.data);
          }
          this.onSaveSuccess();
        },
        (error) => {
          this.onResponseError(error.message);
        }
      );
  }

  updateV3(modal: T) {
    // console.log(JSON.stringify(modal));
    this.getService()
      .updateV3(modal)
      .subscribe(
        (response) => {
          if (response.responseCode != ResponseCode.OK) {
            this.onResponseError(response.responseMessage);
            return;
          }
          //this.setData(response.data);
          if(this.isModelComponent){
            this.saveCallback.emit(response.data);
          }
          this.onSaveSuccess();
        },
        (error) => {
          this.onResponseError(error.message);
        }
      );
  }

  onUpdate() {
    this.update(this.getData());
  }

  onUpdateV2() {
    this.updateV2(this.getData());
  }

  onUpdateV3() {
    this.updateV3(this.getData());
  }

  getById(id: number) {
    this.getService()
      .getById(id)
      .subscribe(
        (response) => {
          this.setData(response.data);
          // if (response.responseCode !== ResponseCode.OK) {
          //     this.onResponseError(response.responseMessage);
          //     return;
          // }
          // this.setData(response.data);
        },
        (error) => {
          this.onResponseError(error.message);
        }
      );
  }

  getByIdV2(id: number) {
    this.getService()
      .getByIdV2(id)
      .subscribe(
        (response) => {
          this.setData(response.data);
          // if (response.responseCode !== ResponseCode.OK) {
          //     this.onResponseError(response.responseMessage);
          //     return;
          // }
          // this.setData(response.data);
        },
        (error) => {
          this.onResponseError(error.message);
        }
      );
  }

  getByIdV3(id: number) {
    this.getService()
      .getByIdV3(id)
      .subscribe(
        (response) => {
          this.setData(response.data);
          // if (response.responseCode !== ResponseCode.OK) {
          //     this.onResponseError(response.responseMessage);
          //     return;
          // }
          // this.setData(response.data);
        },
        (error) => {
          this.onResponseError(error.message);
        }
      );
  }
  onSubmit() {
    this.supressMessage = false
    this.submitted = true;

    if (this.getFormGroup().invalid) {
      this.toastr.warning('Please Fill All Require Fileds','WARNING');
      return;
    }

    if (this.isUpdateComponent) {
      this.onUpdate();
      return;
    }

    if (confirm('Are you sure you want to save this record?')) {
      this.onSave();
    }
  }

  onSubmitsupressMessage() {
    this.supressMessage = true
    this.submitted = true;

    if (this.getFormGroup().invalid) {
      this.toastr.warning('Please Fill All Require Fileds','WARNING');
      return;
    }

    if (this.isUpdateComponent) {
      this.onUpdate();
      return;
    }

    if (confirm('Are you sure you want to submit registeration request?')) {
      this.onSave();
    }
  }

  onSubmitV2() {
    this.submitted = true;

    if (this.getFormGroup().invalid) {
      return;
    }

    if (this.isUpdateComponent) {
      this.onUpdateV2();
      return;
    }

    if (confirm('Are you sure you want to save this record?')) {
      this.onSaveV2();
    }
  }

  onSubmitV3() {
    this.submitted = true;
    if (this.getFormGroup().invalid) {
      return;
    }
    if (this.isUpdateComponent) {
      this.onUpdateV3();
      return;
    }
    if (confirm('Are you sure you want to save this record?')) {
      this.onSaveV3();
    }
  }

  onSubmitWithImage() {
    this.submitted = true;
    if (this.getFormGroup().invalid) {
      return;
    }

    if (this.isUpdateComponent) {
      this.onUpdateWithImage();
      return;
    }

    if (confirm('Are you sure you want to save this record?')) {
      this.onSaveWithImage();
    }
  }

  onSubmitWithImageV2() {
    this.submitted = true;
    if (this.getFormGroup().invalid) {
      return;
    }

    if (this.isUpdateComponent) {
      this.onUpdateWithImageV2();
      return;
    }

    if (confirm('Are you sure you want to save this record?')) {
      this.onSaveWithImageV2();
    }
  }

  onSubmitWithImageV3() {
    this.submitted = true;
    if (this.getFormGroup().invalid) {
      return;
    }
    if (this.isUpdateComponent) {
      this.onUpdateWithImageV3();
      return;
    }
    if (confirm('Are you sure you want to save this record?')) {
      this.onSaveWithImageV3();
    }
  }

  onCancel() {
    if(this.isModelComponent){
      this.cancelCallback.emit();
    }else{
      this.goToModuleHome();
    }
  }

  public onSaveSuccess() {
    if (!this.isModelComponent) {
      this.goToModuleHome();
    }

    if(!this.supressMessage){
      this.toastr.success('Data has been save successfully.', 'Success');
    }
  }

  public onUpdateSuccess() {
    this.toastr.success('Data has been updated successfully.', 'Success');
    this.goToModuleHome();
  }

  public onResponseError(message: string) {
    this.toastr.error(message.replace('\n', '<br/>'), 'Error', { enableHtml: true });
  }

  public goToModuleHome() {
    this.routerSrv.navigate([this.getModuleHomeUrl()]);
  }

  /*  public isModelComponent() : boolean{
         return false;
     } */

  public updateProfileImage(foreinKey: number, module: string, file: File) {
    this.getService()
      .updateImage(foreinKey, module, file)
      .subscribe(
        (response) => {
          if (response.responseCode != ResponseCode.OK) {
            this.onResponseError(response.responseMessage);
            return;
          }
          //this.setData(response.data);
          this.onUpdateSuccess();
        },
        (error) => {
          this.onResponseError(error);
        }
      );
  }

  public getFile(): Array<File> {
    return;
  }

  keypress(event: any) {
    const pattern = /[0-9-,/\.]/;
    let inputChar = String.fromCharCode(event.charCode);

    if (event.keyCode != 8 &&  event.keyCode != 9 && !pattern.test(inputChar)) {
      event.preventDefault();
    }
  }
  public numberOnlyValidation = Validators.pattern(/^\d*(?:[.,]\d{1,4})?$/);

  public validateResponse(response, fun: Function) {
    if (response.responseCode !== ResponseCode.OK) {
      this.toastr.error(response.responseMessage, 'Error');
      return;
    }

    fun();
  }

  public authRole() {
    // Id 1 for admin, Id 2 for staff, Id 3 for SuperAdmin, Id 4 for other.
    const activeUser = JSON.parse(localStorage.getItem('activeUser'));
    if (activeUser && activeUser.role && activeUser.role.roleid) {
      if (activeUser.role.roleid === 1 || activeUser.role.roleid === 3) {
        this.isUserAllow = true;
      }
      if (activeUser.role.roleid === 2 || activeUser.role.roleid === 4) {
        this.isUserAllow = false;
      }
    }
  }
  public hideDeleteButton(): boolean {
    return false;
  }
  private initAcl() {
    try {
      this.isDeleteAllow = !this.hideDeleteButton();
      let aclModule: Map<string, AclDataModal> = new Map<string, AclDataModal>();
      let aclDataString = localStorage.getItem(environment.ACL_LOCAL_KEY);
      if (aclDataString) { 
        aclModule = new Map(JSON.parse(aclDataString));
        let serviceName: string = this.getService().getModuleName();
        let acl: AclDataModal = aclModule.get(serviceName);

        if (acl) {
          this.isAddAllow = acl.create == 1;
          this.isDeleteAllow = acl.delete == 1 && !this.hideDeleteButton();
          this.isEditAllow = acl.update == 1;
          this.isViewAllow = acl.view == 1;
        }
      }
    } catch (e) {
      console.error('Error in initAcl', e);
    }
  }
}
